/* Elysian footer, "within the mountains" variant (2026-09-27): depth motion as the footer enters.
   Sets --rf-p on the footer from 0 (its top edge at the bottom of the viewport) to 1 (its top half in view); the CSS turns it into a
   small rise of the front ridge and a smaller one of the grey range and the wordmark (round 2). Listens to scroll only while the footer is near the viewport.
   Does nothing with reduced motion, or without IntersectionObserver / requestAnimationFrame: everything stays at rest. */
(function () {
  var root = document.querySelector('[data-ely-rf]');
  if (!root || !window.requestAnimationFrame || !('IntersectionObserver' in window)) return;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  if (mq && mq.matches) return;
  var range = root;
  var queued = false;
  var listening = false;
  var update = function () {
    queued = false;
    var r = range.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var p = (vh - r.top) / Math.max(1, r.height * 0.5);
    p = p < 0 ? 0 : (p > 1 ? 1 : p);
    root.style.setProperty('--rf-p', p.toFixed(3));
  };
  var onScroll = function () { if (!queued) { queued = true; window.requestAnimationFrame(update); } };
  var start = function () { if (listening) return; listening = true; window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); onScroll(); };
  var stop = function () { if (!listening) return; listening = false; window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); update(); };
  update();
  root.setAttribute('data-ely-rf-live', '');
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
  }, { rootMargin: '200px 0px' }).observe(range);
  if (mq && mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) { stop(); root.removeAttribute('data-ely-rf-live'); } });
})();
